import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appTutorialSlide]',
})
export class TutorialWizardSlideDirective {
  @HostBinding('class.tutorial-slide') tutorialSlideClass = true;
  @HostBinding('style.flex') flex = '0 0 100%';
  @HostBinding('style.min-width') minWidth = '0';
  @HostBinding('style.height') height = '100%';
  @HostBinding('style.display') display = 'flex';
  @HostBinding('style.flex-direction') flexDirection = 'column';
  @HostBinding('style.overflow-y') overflowY = 'auto';
  @HostBinding('style.overflow-x') overflowX = 'hidden';
}
